import axios from 'axios';
import { BASE_URL } from '../../constants/index';

export const MUTE_ALERT = async (e) => {
  const res = await axios.post(BASE_URL + `/admin/alerts/${e.alertId}`, { muted: e.muted });
  return res.data;
};

export const ADD_TICKET_REPLY = async (e) => {
  const { ticket_id, ...rest } = e;
  const res = await axios.post(BASE_URL + `/admin/tickets/${ticket_id}`, rest);
  return res.data;
};

export const LOGIN_TO_PORTAL = async (e) => {
  const { portal, user } = e;
  const res = await axios.post(BASE_URL + `/admin/logintoportal`, { portal: portal, user: user });
  return res.data;
};

export const SEARCH = async (e) => {
  const { searchResult } = e;
  const res = await axios.post(BASE_URL + `/admin/search`, { search: searchResult });
  return res.data;
};

export const ADD_A_NOTE = async (e) => {
  const { ticketId, notetxt } = e;
  const res = await axios.post(BASE_URL + `/admin/tickets/notes`, { ticket_id: ticketId, note: notetxt });
  return res.data;
};

export const CLOSE_TICKET = async (e) => {
  const { ticketId, actiontxt, summarytxt } = e;
  const res = await axios.post(BASE_URL + `/admin/tickets/actions`, {
    ticket_id: ticketId,
    action: actiontxt,
    summary: summarytxt,
  });
  return res.data;
};

export const ADD_STAFF_NOTES = async (e) => {
  const { ticket_reference, note, when, scheduled_date } = e;
  const res = await axios.post(BASE_URL + `/admin/staff/notes`, {
    ticket_reference: ticket_reference,
    note: note,
    when: when,
    scheduled_date: scheduled_date,
  });
  return res.data;
};

export const ADMIN_ACTIONS = async (e) => {
  const { action, id } = e;
  const res = await axios.post(BASE_URL + `/admin/actions`, {
    action: action,
    id: id,
  });
  return res.data;
};

export const CREATE_TICKET = async (e) => {
  const res = await axios.post(BASE_URL + `/admin/tickets/create`, {
    ...e,
  });
  return res.data;
};
